import PropTypes from 'prop-types';
// components
import Label from 'src/components/label';
import Iconify from 'src/components/iconify';
import CustomPopover, { usePopover } from 'src/components/custom-popover';
import { ConfirmDialog } from 'src/components/custom-dialog';
//
// import UserQuickEditForm from '../user/user-quick-edit-form';import PropTypes from 'prop-types';
// @mui
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import TableRow from '@mui/material/TableRow';
import Checkbox from '@mui/material/Checkbox';
import TableCell from '@mui/material/TableCell';
import IconButton from '@mui/material/IconButton';
import ListItemText from '@mui/material/ListItemText';
import { Box } from '@mui/system';
// hooks
import { useBoolean } from 'src/hooks/use-boolean';
import MstQuickEditForm from './SubScrSiteMst';


// ----------------------------------------------------------------------

export default function MstTableRow({ row, selected, fullAccess, onEditRow, onSelectRow, onDeleteRow, getArrData, numselected }) {

  const { id, mst,country, state, city, End, Start , status } = row;

  const confirm = useBoolean();

  const quickEdit = useBoolean();


  const handleQuickEditClick = () => {
    quickEdit.onTrue();
  };
  const handleDeleteClick = () => {
    confirm.onTrue();
  };

  // Disable delete if the row is inactive or bulk delete is active
  const isDeleteDisabled = status === 'Inactive' || numselected !== 0;
 
  // Disable edit if the row is inactive or bulk delete is active
  const isEditDisabled = numselected !== 0;
  return (
    <>
      <TableRow
        hover
        selected={selected}
      >
        <TableCell padding="checkbox">
          <Checkbox checked={selected} onClick={onSelectRow} />
        </TableCell>

        <TableCell sx={{ whiteSpace: 'nowrap' ,  width: '300px', }}>{mst}</TableCell>

        <TableCell
          sx={{
            whiteSpace: 'normal',
            width: '200px',
            wordBreak: 'break-word',
          }}
        >
          {/* // {country.countryName} */}
          {country?.countryName || '-'}
        </TableCell>

        <TableCell
          sx={{
            whiteSpace: 'normal',
            width: '200px',
            wordBreak: 'break-word',
          }}
        >
          {/* // {state.stateName} */}
          {state?.stateName || '-'}
        </TableCell>

        <TableCell
          sx={{
            whiteSpace: 'normal',
            width: '200px',
            wordBreak: 'break-word',
          }}
        >
          {/*  {city.cityName} */}
          {city?.cityName || '-'}
        </TableCell>

        <TableCell align="right" sx={{ px: 1, whiteSpace: 'nowrap' }}>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
          {fullAccess && (
            <>
              {/* Quick Edit Button */}
              <Tooltip title="Quick Edit" placement="top" arrow>
                <IconButton
                  color="warning"
                  onClick={handleQuickEditClick}
                  disabled={isEditDisabled}
                >
                  <img
                    src="/assets/icons/menu-items/pencil-fill.png"
                    alt="Edit pencil"
                    className="master-menuitem-img"
                    style={{
                      filter: isEditDisabled ? 'grayscale(100%)' : 'none',
                      opacity: isEditDisabled ? 0.5 : 1,
                    }}
                  />
                </IconButton>
              </Tooltip>

              {/* Delete Button */}
              <Tooltip title="Delete" placement="top" arrow>
                <IconButton
                  onClick={handleDeleteClick}
                  disabled={isDeleteDisabled}
                  sx={{
                    color: isDeleteDisabled ? 'gray' : 'error.main',
                  }}
                >
                  <img
                    src="/assets/icons/menu-items/solar--trash-bin-trash-bold.png"
                    alt="recycle bin"
                    className="master-menuitem-img"
                    style={{
                      filter: isDeleteDisabled ? 'grayscale(100%)' : 'none',
                      opacity: isDeleteDisabled ? 0.5 : 1,
                    }}
                  />
                </IconButton>
              </Tooltip>
            </>
          )}
       </Box>
        </TableCell>

      </TableRow>

      <MstQuickEditForm
        currentUser={row}
        open={quickEdit.value}
        onClose={quickEdit.onFalse}
        getArrData={getArrData} />

      <ConfirmDialog
        open={confirm.value}
        onClose={confirm.onFalse}
        title="Delete Subscriber Site"
        content="Are you sure you want to delete?"
        action={
          <Button variant="contained" color="error" onClick={onDeleteRow}>
            Delete
          </Button>
        }
      />
    </>
  );
}

MstTableRow.propTypes = {
  onDeleteRow: PropTypes.func,
  onEditRow: PropTypes.func,
  onSelectRow: PropTypes.func,
  row: PropTypes.object,
  fullAccess: PropTypes.bool,
  selected: PropTypes.bool,
  getArrData: PropTypes.func,
  numselected: PropTypes.number,
};
